<main class="px-3 md:px-5 2xl:px-28 3xl:px-52">
  <section
    class="container mx-auto min-h-[80vh] flex flex-col-reverse lg:flex-row items-center justify-center gap-7"
  >
    <section class="flex flex-col gap-3 lg:basis-[50%]">
      <h1 class="text-4xl font-bold">You're now logged out!</h1>
      <p class="text-gray-600">
        You'll need to log in to buy or sell a used Tesla and manage your
        listings.
      </p>
      <p class="text-gray-600">
        If you are experiencing any issues, get in touch by emailing us at
        <a
          class="text-blue-400 hover:text-blue-600 transition-colors duration-300"
          href="mailto:contact@onlyusedtesla.com"
          >contact&commat;onlyusedtesla.com.</a
        >
      </p>
      <button
        (click)="login()"
        class="bg-OUT-Blue hover:bg-OUT-Blue/90 transition-colors duration-400 cursor-pointer text-white px-5 py-1.5 rounded-full w-fit"
      >
        Sign In to Continue
      </button>
    </section>
    <section class="lg:basis-[50%] bg-black rounded-lg h-full">
      <img
        src="/assets/images/Model3_64.webp"
        class="rounded-lg object-cover"
        alt="Model 3 images"
      />
    </section>
  </section>
</main>